import { API_URL } from "../../../../constants";
import * as httpNetworking from "../../../../httpNetworking";

const URL = API_URL + "/website/features/interested";
const VERSION = 0;

/**
 * Send list of interested features
 */
export default async function sendInterestedFeatures(features: string[]): Promise<{}> {
    let response = (await httpNetworking.simplePOSTRequest(URL, { features }, {}, VERSION)).data;
    return response;
}
